<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="终端主机号/车牌号/车架号" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style="margin-right: 10px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click=onprocessAlarm>批量处理</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"
                 @on-select="onselect" @on-select-all="onselectall"
          ></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <process-alarm-modal v-model="processAlarmModal" :initValue="processAlarmId" @on-success="onModifySuccess"></process-alarm-modal>
    <batch-process-alarm-modal v-model="batchProcessAlarmModal" :initValue="batchProcessAlarmId" @on-success="onModifySuccess"></batch-process-alarm-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import ProcessAlarmModal from '@/view/da/components/process-alarm-modal'
import BatchProcessAlarmModal from '@/view/da/components/batch-process-alarm-modal'

export default {
  name: 'alarmanalysiss',
  components: {
    ProcessAlarmModal,
    BatchProcessAlarmModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      stateFilter: null,
      alarmFilter: null,

      // 报警处理
      processAlarmModal: false,
      processAlarmId: null,

      // 批量报警处理
      batchProcessAlarmModal: false,
      batchProcessAlarmId: null,

      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      /**
       * 多选列表
       */
      processAnalysisResultList:[],

      columns: [
        {
          width: 55,
          type: 'selection'
        },
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '终端主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '终端登记车牌号',
          resizable: true,
          key: 'registrationNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120
        },
        {
          title: '终端登记车架号',
          resizable: true,
          key: 'vin',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180
        },
        {
          title: '报警内容',
          resizable: true,
          key: 'alarm',
          ellipsis: 'true',
          tooltip: 'true',
          width: 160,
          filters: [
            { label: '紧急报警', value: '紧急报警' },
            { label: '超速报警', value: '超速报警' },
            { label: '疲劳驾驶', value: '疲劳驾驶' },
            { label: '危险预警', value: '危险预警' },
            { label: 'GNSS模块发生故障', value: 'GNSS模块发生故障' },
            { label: 'GNSS天线未接或被剪断', value: 'GNSS天线未接或被剪断' },
            { label: 'GNSS天线短路', value: 'GNSS天线短路' },
            { label: '终端主电源欠压', value: '终端主电源欠压' },
            { label: '终端主电源掉电', value: '终端主电源掉电' },
            { label: '终端LCD或显示器故障', value: '终端LCD或显示器故障' },
            { label: 'TTS模块故障', value: 'TTS模块故障' },
            { label: '道路运输证IC卡模块故障', value: '道路运输证IC卡模块故障' },
            { label: '超速预警', value: '超速预警' },
            { label: '疲劳驾驶预警', value: '疲劳驾驶预警' },
            { label: '当天累计驾驶超时', value: '当天累计驾驶超时' },
            { label: '超时停车', value: '超时停车' },
            { label: '进出区域', value: '进出区域' },
            { label: '进出路线', value: '进出路线' },
            { label: '路段行驶时间不足/过长', value: '路段行驶时间不足/过长' },
            { label: '车辆VSS故障', value: '车辆VSS故障' },
            { label: '车辆油量异常', value: '车辆油量异常' },
            { label: '车辆被盗(通过车辆防盗器)', value: '车辆被盗(通过车辆防盗器)' },
            { label: '车辆非法点火', value: '车辆非法点火' },
            { label: '车辆非法位移', value: '车辆非法位移' },
            { label: '碰撞预警', value: '碰撞预警' },
            { label: '侧翻预警', value: '侧翻预警' },
            { label: '非法开门报警', value: '非法开门报警' }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.alarmFilter = []
              val.forEach(item => {
                this.alarmFilter.push(genQueryParam('alarm', 'LIKE', '%25' + item + '%25'))
              })
              this.setPage(1)
            } else {
              this.alarmFilter = null
            }
          }
        },
        {
          title: '处理状态',
          resizable: true,
          key: 'state',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '未处理', value: 1 },
            { label: '继续跟进', value: 2 },
            { label: '已处理', value: 3 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.state
            if (state === 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '未处理')
              ])
            } else if (state === 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '继续跟进')
              ])
            } else if (state === 3) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '已处理')
              ])
            }
          }
        },
        {
          title: '处理结果',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key:'result',
          width: 120,
        },
        {
          title: '统计时间段',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 360,
          render: function (h, params) {
            if (params.row.startDatetime && params.row.endDatetime) {
              let sd = new Date(params.row.startDatetime)
              let ed = new Date(params.row.endDatetime)
              return h('label', sd.Format('yyyy年MM月dd日 hh:mm:ss') + '~' + ed.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          minWidth: 90,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.processAlarmId = params.row.id
                    this.processAlarmModal = true
                  }
                }
              }, '报警处理')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'ClientInfoServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    filterChange () {
      this.setPage(1)
    },
    onselect(selection,row){
      this.processAnalysisResultList = []
      selection.forEach(item =>{
        this.processAnalysisResultList.push(item.id)
      })
    },
    onselectall(selection){
      this.processAnalysisResultList = []
      selection.forEach(item =>{
        this.processAnalysisResultList.push(item.id)
      })
    },
    onprocessAlarm(){
      /**
       * 给id列表
       * 给处理内容
       * 后端批量处理
       */
      this.batchProcessAlarmModal = true;
      this.batchProcessAlarmId = this.processAnalysisResultList;
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null
      let qo1 = null
      let qo2 = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      }
      if (this.alarmFilter) {
        qo2 = this.alarmFilter
      }

      store.dispatch('AlarmAnalysisServ_GetPage', {
        params: null,
        urlparams: {
          qo1: qo1,
          qo2: qo2,
          q: queryParams,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter =value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_AlarmAnalysis_GetPageResult) {
        return store.getters.get_AlarmAnalysis_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_AlarmAnalysis_GetPageResult) {
        return store.getters.get_AlarmAnalysis_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_AlarmAnalysis_GetPageResult) {
        return store.getters.get_AlarmAnalysis_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
